import { getApiHostWithoutEnv } from '@fund/api-host';
import { Create } from '@fund/api-modules';
import { Caches } from '../components/FundChart/model/decorator';
import pageConfigModel from '../model/page-config.model';
import CreateByUser from './decorator/CreateByUser';
import TransformResponse from './decorator/TransformResponse';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken,
      ctoken,
      uid,
      deviceid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      version: '6.5.5',
      ServerVersion: '6.5.5',
      customerno: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})

@Create({
  baseURL: getApiHostWithoutEnv('appactive'), // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  // baseURL: 'https://appactiveneice.1234567.com.cn',
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'web',
  },
})

class ConfigApi {
  getWxConfigure(FCODE) {
    return this.GET('/AppoperationApi/Modules/GetModuleConfig', {
      PageType: 'WXHomeNew',
      FCODE,
    });
  }

  getWxJumpConfig(isTest) {
    return this.GET('/operationapi/lowCode/getModuleContent', {
      appId: 'e1dff06085d65a80b6da0442155e9893',
      moduleCode: isTest ? 'cs-xcxdzysb_1tusr9f' : 'xcxdzysb_9x4w2xh',
    });
  }

  @Caches(30 * 60 * 1000)
  getFundConfigure(FCODE) {
    return this.GET('/AppoperationApi/Modules/GetModuleConfig', {
      PageType: 'FundDetail',
      FCODE,
    });
  }

  // @Caches(30 * 60 * 1000)
  @TransformResponse((res) => pageConfigModel.objectWithKeyValues(res.datas || {}))
  getFundPageConfigure(FCODE) {
    return this.GET('/AppoperationApi/Modules/GetModuleConfig', {
      PageType: 'FundDetail',
      FCODE,
    });
  }

  getADConfigure(FCODE) {
    return this.JSONP('/usercenter/FundDetail', {
      FundCode: FCODE,
    });
  }
}
export default new ConfigApi();
